import SegmentationGroupTable from './SegmentationGroupTable';

export default SegmentationGroupTable;
